export default __webpack_public_path__ + "static/media/tng.1540d0a1.svg";